(function () {
  if (window.__nad3Reset) return;
  window.__nad3Reset = true;

  function selectOption(input) {
    var box = input.closest('[data-nr-offer]');
    if (!box) return;
    var idEl = box.querySelector('[data-nr-id]');
    var planEl = box.querySelector('[data-nr-plan]');
    if (idEl && input.getAttribute('data-variant')) idEl.value = input.getAttribute('data-variant');
    if (planEl) {
      var plan = input.getAttribute('data-plan');
      if (plan) { planEl.value = plan; planEl.disabled = false; }
      else { planEl.value = ''; planEl.disabled = true; }
    }
    box.querySelectorAll('.nr-opt').forEach(function (o) { o.classList.toggle('is-active', o.contains(input)); });
  }

  function applyReviews(root) {
    var cat = root.getAttribute('data-filter') || 'all';
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 3;
    var shown = 0, total = 0;
    root.querySelectorAll('[data-nr-review]').forEach(function (r) {
      var cats = (r.getAttribute('data-cat') || '').split(',').map(function (c) { return c.trim(); });
      var match = cat === 'all' || cats.indexOf(cat) > -1;
      if (match) {
        total++;
        if (shown < limit) { r.hidden = false; shown++; } else { r.hidden = true; }
      } else { r.hidden = true; }
    });
    var more = root.querySelector('[data-nr-more]');
    if (more) more.hidden = shown >= total;
  }

  function initAll(scope) {
    var s = scope || document;
    s.querySelectorAll('[data-nr-reviews]').forEach(applyReviews);
    s.querySelectorAll('[data-nr-option]:checked').forEach(selectOption);
  }

  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-nr-option]')) selectOption(e.target);
  });

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-nr-thumb]');
    if (thumb) {
      var g = thumb.closest('[data-nr-gallery]');
      var i = parseInt(thumb.getAttribute('data-nr-thumb'), 10);
      g.querySelectorAll('[data-nr-slide]').forEach(function (sl, idx) { sl.classList.toggle('is-active', idx === i); });
      g.querySelectorAll('[data-nr-thumb]').forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      return;
    }
    var pill = e.target.closest('[data-nr-filter]');
    if (pill) {
      var root = pill.closest('[data-nr-reviews]');
      root.setAttribute('data-filter', pill.getAttribute('data-nr-filter'));
      root.setAttribute('data-limit', root.getAttribute('data-step'));
      root.querySelectorAll('[data-nr-filter]').forEach(function (p) { p.classList.toggle('is-active', p === pill); });
      applyReviews(root);
      return;
    }
    var more = e.target.closest('[data-nr-more]');
    if (more) {
      var r = more.closest('[data-nr-reviews]');
      r.setAttribute('data-limit', (parseInt(r.getAttribute('data-limit'), 10) || 3) + (parseInt(r.getAttribute('data-step'), 10) || 3));
      applyReviews(r);
    }
  });

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var b = e.target;
    if (!b || !b.hasAttribute) return;
    if (b.hasAttribute('data-nr-review')) b.hidden = false;
    if (b.hasAttribute('data-nr-slide')) {
      var g = b.closest('[data-nr-gallery]');
      if (g) g.querySelectorAll('[data-nr-slide]').forEach(function (sl) { sl.classList.toggle('is-active', sl === b); });
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
})();
